// Output encoding (§A.3.5). HTML-escape ALL transcript-derived / model-derived text before
// it touches the DOM. Never assign such text via innerHTML — always textContent or escapeHtml.

export function escapeHtml(s: unknown): string {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Set text safely (preferred — uses textContent, no HTML parsing). */
export function setText(el: Element, value: unknown): void {
  el.textContent = String(value ?? '');
}
